import React from 'react'
import { Tooltip as ChakraTooltip, TooltipProps } from '@chakra-ui/react'
import styles from './Tooltip.module.scss'

const Tooltip: React.FC<TooltipProps> = ({ ...props }) => {
  return <ChakraTooltip className={styles.tooltip} {...props} />
}

export default Tooltip
